import React, { useState, useEffect } from 'react'
import { useFetch } from './useFetch'
import Follower from './Follower'

function App() {
  const { loading, data } = useFetch()
  const [page, setPage] = useState(0)
  const [followers, setFollowers] = useState([])

  useEffect(() => {
    if (loading)
      return
    setFollowers(data[page])
  }, [loading, page])

  const handlePage = (index) => {
    setPage(index)
  }

  const prevPage = () => {
    setPage((oldPage) => {
      let prevPage = oldPage - 1
      if (prevPage < 0)
        prevPage = data.length - 1

      return prevPage
    })
  }

  const nextPage = () => {
    setPage((oldPage) => {
      let nextPage = oldPage + 1
      if (nextPage >= data.length)
        nextPage = 0

      return nextPage
    })
  }

  return (
    <section>
      <div className="section-title">
        <h1>{loading ? 'loading...' : 'GitHub Followers'}</h1>
        <div className="underline"></div>
      </div>
      {!loading && (
        <div className="btn-container">
          <button className="prev-btn" onClick={prevPage}>prev</button>
          {data.map((item, index) => {
            return (
              <button key={index} className={`page-btn ${index === page ? 'active-btn' : ''}`} onClick={() => handlePage(index)}>{index + 1}</button>
            )
          })}
          <button className='next-btn' onClick={nextPage}>next</button>
        </div>
      )}
      <div className="followers">
        <div className="container">
          {followers.map((follower) => {
            return <Follower key={follower.id} {...follower} />
          })}
        </div>
        {!loading && (
          <div className="btn-container">
            <button className="prev-btn" onClick={prevPage}>prev</button>
            {data.map((item, index) => {
              return (
                <button key={index} className={`page-btn ${index === page ? 'active-btn' : ''}`} onClick={() => handlePage(index)}>{index + 1}</button>
              )
            })}
            <button className='next-btn' onClick={nextPage}>next</button>
          </div>
        )}
      </div>
    </section>
  );
}

export default App;
